import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router";
import { useBranding } from "../../branding/useBranding";
import RefreshButton from "../../components/buttons/RefreshButton";
import { useAtom } from "jotai";
import { selectedSearchAtom } from "../../jotai/atoms";
import { ImageIcon } from "../ImageIcon";
import { useModal } from "../../context/ModalContext";

interface MobileNavbarState {
  back?: boolean;
  title?: string;
}

export default function MobileNavbar({ drawerId }: { drawerId: string }) {
  const branding = useBranding();
  const navigate = useNavigate();
  const { pathname, state } = useLocation();
  // We need a way to back more dynamic state to the Mobile Navbar without passing props
  // everywhere up and down the DOM tree.
  const { back, title } = (state as MobileNavbarState) || {};
  const [showBack, setShowBack] = useState(false);
  const [headerTitle, setHeaderTitle] = useState<string>();
  const [, setCurSearch] = useAtom(selectedSearchAtom);
  const modal = useModal();

  const getHeaderTitle = () => {
    if (pathname === "/home/search/altcontacts") {
      return "Verification Needed";
    } else if (pathname === "/home/settings") {
      return "Settings";
    } else if (pathname === "/home/search/enterpin") {
      return "Enter PIN";
    } else if (pathname === "/home/discover") {
      // TODO Translate
      return "Partners";
    } else if (title) {
      return title;
    }
    return undefined;
  };

  useEffect(() => {
    const navBackUrls = [
      "/home/search/altcontacts",
      "/home/search/enterpin",
      "/home/records/events",
    ];
    setShowBack(navBackUrls.includes(pathname) || !!back);
    setHeaderTitle(getHeaderTitle());
  }, [pathname, back, title]);

  const renderActionButtons = () => {
    if (pathname === "/home/search") {
      return (
        <div className="my-auto flex justify-end">
          <button
            onClick={async () => {
              await setCurSearch(null);
              modal.openSearchModal();
            }}
            className="btn btn-primary btn-ghost text-primary-content"
          >
            <ImageIcon src="/assets/images/Icon_Search_New_White.png" />
          </button>
        </div>
      );
    } else if (pathname === "/home/records" || pathname === "/home/records/screening") {
      return (
        <div className="w-1/5 my-auto justify-end flex">
          <RefreshButton />
        </div>
      );
    }

    return <div className="w-1/5" />;
  };

  return (
    <>
      <div
        data-testid="mobile-navbar-banner"
        className="md:hidden flex drawer-content min-h-20 fixed w-full z-10 bg-secondary top-[env(safe-area-inset-top)]"
      ></div>
      <div
        data-testid="mobile-navbar-actions"
        className="md:hidden flex gap-2 drawer-content min-h-20 px-4 fixed w-full z-50 bg-transparent top-[env(safe-area-inset-top)] justify-between"
      >
        <div className="flex items-center w-full gap-2">
          {showBack ? (
            <div className="">
              <button
                onClick={() => navigate(-1)}
                className="btn btn-primary btn-ghost text-primary-content"
              >
                <ImageIcon
                  className="w-[calc(var(--size)*0.5)] h-[calc(var(--size)*0.5)]"
                  src="/assets/images/chevron_left_white_square.png"
                />
              </button>
            </div>
          ) : (
            <label htmlFor={drawerId} className="drawer-overlay my-auto">
              <span className="btn btn-primary btn-ghost  text-primary-content">
                <ImageIcon className="" src="/assets/images/burger_menu.png" />
              </span>
            </label>
          )}

          <div className="my-auto">
            {!headerTitle ? (
              <></>
            ) : (
              <p className="text-white font-semibold text-left text-xl whitespace-nowrap">
                {headerTitle}
              </p>
            )}
          </div>
        </div>
        {renderActionButtons()}
      </div>
    </>
  );
}
